const duplicateTranslationKey = (key: string): string => key;

export const translationStatistics_sv_part3 = {
  statisticsSettings: "Statistikinställningar",
  statisticsVisibility: "Statistiksynlighet",
  statisticsVisibilityDescription:
    "Välj vilken statistik som ska visas på huvudstatistiksidan. Ändringar sparas automatiskt.",
  aiStatistics: "AI-statistik",
  conversations: "konversationer",
  topicsManagementTitle: "Ämnen",
  topicsManagementDescription:
    "Hantera de ämnen AI:n använder för att kategorisera konversationer. Beskrivningen vägleder AI:ns klassificering.",
  topicsSelectSingleChatbot: "Välj en enskild chatbot för att hantera ämnen.",
  topicsInheritedBanner: "Ämnen ärvs från den överordnade chatboten.",
  topicsCustomize: "Anpassa",
  topicsCustomized: "Ämnen kopierades och kan nu anpassas.",
  topicsLoadError: "Kunde inte läsa in ämnen",
  topicName: "Namn",
  topicDescriptionLabel: "Beskrivning",
  topicDescriptionHint: "Lägg till beskrivning...",
  topicAdd: "Lägg till ämne",
  topicNewNamePlaceholder: "Nytt ämne...",
  topicNewDescriptionPlaceholder: "Beskrivning (valfritt)",
  topicCreated: "Ämne skapat",
  topicDeleted: "Ämne borttaget",
  topicDelete: "Ta bort ämne",
  topicArchivedBadge: "Arkiverat",
  topicMergeExplanation:
    "Välj vilket ämne dess konversationer ska flyttas till — sedan tas ämnet bort.",
  topicMergeTargetLabel: "Flytta konversationer till",
  topicMergeConfirm: "Flytta och ta bort",
  topicDeleteConfirmTitle: "Ta bort ämne?",
  topicDeleteConfirmDescription:
    "Ämnet har inga konversationer kopplade till sig och kommer att tas bort permanent.",
  topicNoTopics: "Inga ämnen ännu. Lägg till ett ämne nedan.",
  topicsScopeOrg: "Delat inom organisationen",
  topicsScopeBrand: "Varumärkesspecifika ämnen",
  topicsScopeChatbot: "Endast den här chatboten",
  topicsCustomizeForChatbot: "Anpassa enbart för den här chatboten",
  topicsCustomizeForBrand: "Anpassa för det här varumärket",
  topicsBrandUsesOrg: "Det här varumärket använder organisationens gemensamma ämnen.",
  topicSubtagsLabel: "Taggar",
  topicSubtagsHint: "Taggar som AI:n kan använda för det här ämnet (tags(...)).",
  topicAddTagPlaceholder: "Lägg till tagg...",
  topicRemoveTag: "Ta bort tagg",
  freshdeskTagsTitle: "Freshdesk-taggar",
  freshdeskTagsDescription:
    "Taggar som AI:n kan lägga på Freshdesk-ärenden via e-postautomatisering.",
  livechatStatistics: "Live Chat-statistik",
  totalLivechatConversations: "Totala livechat-konversationer",
  avgLivechatPerDay: "Genomsnittlig livechat per dag",
  livechatPercentage: "Livechat-andel",
  avgResponseTime: "Genomsnittlig svarstid",
  totalResponses: "Totala svar",
  livechatStatisticsDescription:
    "Följ livechat-volym, svarstider och kundfeedback för de valda chatbotarna.",
  dailyLivechatSessions: "Dagliga livechat-sessioner",
  livechatSessionsByHour: "Livechat-sessioner per tid på dygnet",
  livechatStatusDistribution: "Statusfördelning",
  livechatStatusWaiting: "Väntar",
  livechatStatusActive: "Aktiv",
  livechatStatusClosed: "Stängd",
  livechatWaitingSessions: "Väntande sessioner",
  livechatActiveSessions: "Aktiva sessioner",
  livechatClosedSessions: "Stängda sessioner",
  avgWaitTime: "Genomsnittlig väntetid",
  avgHandlingTime: "Genomsnittlig handläggningstid",
  livechatTotalRatings: "Livechat-omdömen",
  viewLivechatSessions: "Visa livechat-sessioner",
  noLivechatStatistics: "Ingen livechat-statistik hittades för den valda perioden.",
  totalLivechatConversationsTooltip: "Totalt antal konversationer hanterade via livechat",
  avgLivechatPerDayTooltip: "Genomsnittligt antal livechat-konversationer per dag",
  livechatPercentageTooltip: "Andel av alla konversationer som gick till livechat",
  avgResponseTimeTooltip: "Genomsnittlig tid för agenter att svara på användarmeddelanden",
  totalResponsesTooltip: "Totalt antal svar skickade av agenter i livechat",
  livechatWaitingSessionsTooltip: "Antal livechat-sessioner som väntar på en agent",
  livechatActiveSessionsTooltip: "Antal livechat-sessioner som är aktiva just nu",
  livechatClosedSessionsTooltip: "Antal avslutade livechat-sessioner",
  avgWaitTimeTooltip: "Genomsnittlig tid från livechat-begäran tills en agent ansluter",
  avgHandlingTimeTooltip:
    "Genomsnittlig tid från att agenten ansluter tills livechat-sessionen stängs",
  livechatTotalRatingsTooltip: "Antal kundomdömen inskickade efter livechat-sessioner",
  save: "Spara",
  [duplicateTranslationKey("cancel")]: "Avbryt",

  notificationsPageTitle: "Aviseringar",
  notificationsPageDescription:
    "Ställ in automatiska e-postaviseringar när det sker ovanlig aktivitet på din chatbot. Välj ett ämne, ange hur stor procentuell ökning som ska utlösa aviseringen och ange mätperioden. Du får ett e-postmeddelande när aktiviteten överstiger den angivna procentuella ökningen jämfört med den normala aktiviteten under den valda perioden.",
  notificationsLabelTopic: "Ämne",
  notificationsLoadingTopics: "Laddar ämnen...",
  notificationsSelectTopic: "Välj ett ämne",
  notificationsNoTopics:
    "Inga ämnen hittades. Ämnen genereras automatiskt från dina konversationer.",
  notificationsLabelPercentIncrease: "Procentuell ökning",
  notificationsSelectPercent: "Välj procentuell ökning",
  notificationsLabelTimePeriod: "Tidsperiod",
  notificationsSelectTimePeriod: "Välj tidsperiod",
  notificationsPeriod6Hours: "6 timmar",
  notificationsPeriod12Hours: "12 timmar",
  notificationsPeriod24Hours: "24 timmar",
  notificationsPeriod3Days: "3 dagar",
  notificationsPeriod7Days: "7 dagar",
  notificationsLabelEmail: "E-post",
  notificationsEmailPlaceholder: "Ange e-postadress",
  notificationsSaving: "Sparar...",
  notificationsSaveButton: "Spara aviseringsinställningar",
  notificationsYourSettings: "Dina aviseringsinställningar",
  notificationsLoadingSettings: "Laddar inställningar...",
  notificationsNoSettings: "Du har inga aktiva aviseringsinställningar ännu.",
  notificationsCreateFirst: "Skapa din första avisering ovan.",
  notificationsCardTopic: "Ämne",
  notificationsCardIncrease: "Ökning",
  notificationsCardPeriod: "Period",
  notificationsCardEmail: "E-post",
  notificationsCreatedAt: "Skapad",
  notificationsDeleteButton: "Ta bort",
  notificationsDeleteTitle: "Ta bort avisering",
  notificationsErrorFetchTopics: "Fel vid hämtning av ämnen",
  notificationsErrorFetchSettings: "Fel vid hämtning av aviseringsinställningar",
  notificationsSaveSuccess: "Aviseringsinställningar sparade",
  notificationsSaveError: "Fel vid sparande av inställningar",
  notificationsLoginRequired: "Du måste vara inloggad för att ta bort aviseringar",
  notificationsDeleteSuccess: "Aviseringsinställning borttagen",
};
